import OrderDetailsPopup from '@api/order/components/OrderDetailsPopup'
import { IIcon } from '@components/std-components/TopBar'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import {
  OrderDetailsConfigRetail,
  OrderDetailsConfigWholesale
} from '@modules/order/constants/OrderDetailsConfig'
import OrderContext from '@modules/order/contexts/order-context'
import { ViewContextProvider } from '@modules/order/contexts/view-context'
import { OrderUIStore } from '@modules/order/stores/order/OrderUIStore'
import buyingSessionGroup from '@stores/BuyingSessionGroup'
import { productCurveStore } from '@stores/productCurvesStore'
import { getEnumValue } from '@utils/get-enum-value'
import React, { FC, useEffect, useMemo } from 'react'
import EnhancedViewFactory from './Views/EnhancedViewFactory'
import { useObserver } from 'mobx-react-lite'
import { stores } from '@stores'

export interface EnhancedOrderContainerProps {
  baseUrlNavIconConfig?: IIcon
}

const EnhancedOrderContainer: FC<EnhancedOrderContainerProps> = ({
  baseUrlNavIconConfig
}) => {
  return useObserver(function useHook() {
    const orderContextValue = useMemo(() => ({ uiStore: new OrderUIStore() }), [])
    const {
      nav: {
        queryParams: { clientId, buyingSessionGroupId, clientType, orderId }
      },
      productConfiguration: { saveAppliedGroupFilterSortSearch }
    } = stores

    useEffect(() => {
      productCurveStore.fetchData(clientId, buyingSessionGroupId)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
      orderContextValue.uiStore.init()
      return () => orderContextValue.uiStore.destroy()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId])
    useEffect(() => {
      buyingSessionGroupId && buyingSessionGroup.fetchDataIfNotExist(buyingSessionGroupId)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buyingSessionGroupId])

    useEffect(() => {
      return () => {
        saveAppliedGroupFilterSortSearch('resetAll', null, 'orderCollection')
      }
    }, [saveAppliedGroupFilterSortSearch, orderId])

    return (
      <OrderContext.Provider value={orderContextValue}>
        <ViewContextProvider>
          <EnhancedViewFactory baseUrlNavIconConfig={baseUrlNavIconConfig} />
          <OrderDetailsPopup
            attributesConfig={
              clientType === getEnumValue(VIPClientType.Internal)
                ? OrderDetailsConfigRetail
                : OrderDetailsConfigWholesale
            }
          />
        </ViewContextProvider>
      </OrderContext.Provider>
    )
  })
}

export default EnhancedOrderContainer
